import React from 'react';
import Carousel from 'react-material-ui-carousel';
import { AppBar, Toolbar, Button, Typography, Box, Container } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

const FullHeightCarousel = styled(Carousel)({
    height: '100vh',
    '& .carousel-slider': {
        height: '100%'
    },
    '& .slide': {
        height: '100%'
    }
});

const SlideImage = styled('img')({
    width: '100%',
    height: '100vh',
    objectFit: 'cover',
});

const Footer = styled(Box)({
    position: 'fixed',
    bottom: 0,
    width: '100%',
    padding: '20px',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    color: 'white',
    textAlign: 'center',
    zIndex: 1000
});

const CarouselContainer = styled(Box)({
    position: 'relative',
    height: '100vh',
    '& .MuiPaper-root': {
        zIndex: 1100
    }
});

const TextOverlay = styled(Box)({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
    color: 'white',
    zIndex: 2,
    width: '100%',
    padding: '0 20px',
    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
});

const GradientOverlay = styled(Box)({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5))',
    zIndex: 1,
});

const LandingPage = () => {
    const navigate = useNavigate();

    const slides = [
        {
            url: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?q=80&w=2070",
            alt: "강의장면 1"
        },
        {
            url: "https://images.unsplash.com/photo-1544531585-9847b68c8c86?q=80&w=2070",
            alt: "강의장면 2"
        },
        {
            url: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?q=80&w=2070",
            alt: "강의장면 3"
        }
    ];

    return (
        <CarouselContainer>
            {/* 상단 바 */}
            <AppBar position="fixed" sx={{ backgroundColor: 'rgba(255, 255, 255, 0.9)' }}>
                <Container maxWidth="lg">
                    <Toolbar sx={{ justifyContent: 'space-between' }}>
                        <Typography 
                            variant="h6" 
                            sx={{ 
                                color: '#000', 
                                fontWeight: 'bold',
                                cursor: 'pointer'
                            }}
                        >
                            Guestbook
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            {/* <Button 
                                variant="outlined" 
                                color="primary"
                                onClick={() => window.open('/payment', '_blank')}
                                sx={{
                                    borderRadius: '20px',
                                    padding: '8px 24px'
                                }}
                            >
                                구독하기
                            </Button> */}
                            <Button 
                                variant="contained" 
                                color="primary"
                                sx={{
                                    borderRadius: '20px',
                                    padding: '8px 24px'
                                }}
                            >
                                문의하기
                            </Button>
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>

            <Box sx={{ 
                position: 'relative', 
                height: '100vh',
                zIndex: 1
            }}>
                <FullHeightCarousel
                    animation="slide"
                    interval={5000}
                    indicators={false}
                    swipe={true}
                >
                    {slides.map((slide, index) => (
                        <Box key={index} sx={{ position: 'relative' }}>
                            <SlideImage
                                src={slide.url}
                                alt={slide.alt}
                            />
                            <GradientOverlay />
                        </Box>
                    ))}
                </FullHeightCarousel>

                <TextOverlay>
                    <Typography 
                        variant="h2" 
                        sx={{ 
                            fontWeight: 'bold',
                            mb: 3,
                            fontSize: { xs: '2rem', md: '3.75rem' }
                        }}
                    >
                        실시간 방명록 서비스
                    </Typography>
                    <Typography 
                        variant="h5" 
                        sx={{ 
                            mb: 2,
                            fontSize: { xs: '1.2rem', md: '1.5rem' },
                            lineHeight: 1.8
                        }}
                    >
                        강의와 행사에서 실시간으로 소통하세요
                    </Typography>
                    <Typography 
                        variant="body1" 
                        sx={{ 
                            fontSize: { xs: '1rem', md: '1.2rem' },
                            maxWidth: '800px',
                            margin: '0 auto',
                            lineHeight: 1.8
                        }}
                    >
                        질문, 소감, 방명록을 작성하면<br />
                        실시간으로 화면에 표시됩니다
                    </Typography>
                </TextOverlay>
            </Box>

            <Footer>
                <Typography variant="body2">
                    COPYRIGHT (C) 주식회사 와이드브레인
                </Typography>
            </Footer>
        </CarouselContainer>
    );
};

export default LandingPage; 